import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  checkBoxContainer: {
    marginTop: 30,
    alignItems: 'center',
  },
}));
